<template>
  <div>
    <div class="mobile-banner" v-if="mobile_component">
      <div class="main-page-banner">
        <banner></banner>

      </div>

    </div>
    <div v-else>

      <banner></banner>
    </div>
    <div class="container">
      <div class="container container-fixed">
        <div class="position-relative">
          <img class="arrow-right" src="../assets/images/right-btn.png"
               @click="$router.push({ path: 'cum-construim-sistemul-imunitar' })">
        </div>
      </div>
    </div>
    <div class="container-fluid px-0">

      <consultant></consultant>

      <continut></continut>

      <section class="secretele-laptelui">

          <div class="row justify-content-between">
            <secret-unu class="col-12 pt-30"></secret-unu>

            <secret-doi class="col-12 pt-30"></secret-doi>

        </div>
      </section>
      <section class="middle-banner">
        <div class="container-fluid">
          <div class="container position-relative">

          </div>
        </div>
      </section>
      <section class="secretele-laptelui secret-blue-margin">

          <secret-trei class="col-12 px-0 pt-30"></secret-trei>

        <div class="container">
          <carousel :nav="false" :items=1 :stagePadding=10 v-if="mobile_component" >
            <prebiotic></prebiotic>

              <celule-imunitare></celule-imunitare>
              <sustinere-sistem></sustinere-sistem>


          </carousel>
          <div v-else class="row">

            <prebiotic class="col-lg-4 col-md-12 col-12"></prebiotic>

            <celule-imunitare class="col-lg-4 col-md-12 col-12"></celule-imunitare>
            <sustinere-sistem class="col-lg-4 col-md-12 col-12"></sustinere-sistem>

          </div>
        </div>
      </section>

      <intrebari></intrebari>
      <section>
        <div class="container">
          <div class="col-md-10 offset-md-1">
          <p class="p-gray">FOARTE IMPORTANT<br />Laptele matern este cea mai bună hrană pentru copilul tău, astfel că alăptarea trebuie să dureze o perioadă cât mai îndelungată.
            Se recomandă alăptarea exclusivă cu lapte matern pentru sugarii cu vârsta de până la 6 luni. Formulele de lapte praf Aptamil® NUTRI-BIOTIK™ se folosesc numai la indicația
            și sub îndrumarea medicului sau asistentului medical și numai după instruirea mamei privind utilizarea acestora.</p>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>
<script>
import Banner from '../components/SecreteleLaptelui/Banner.vue'
import Consultant from '../components/SecreteleLaptelui/Consultant.vue'
import Continut from '../components/SecreteleLaptelui/Continut.vue'
import Intrebari from '../components/SecreteleLaptelui/Intrebari.vue'
import SecretUnu from '../components/SecreteleLaptelui/Secret1.vue'
import SecretDoi from '../components/SecreteleLaptelui/Secret2.vue'
import SecretTrei from '../components/SecreteleLaptelui/Secret3.vue'
import CardPrebiotic from '../components/SecreteleLaptelui/CardPrebiotic.vue'
import CardCeluleImunitare from '../components/SecreteleLaptelui/CardCeluleImunitare.vue'
import CardSustinereSistem from '../components/SecreteleLaptelui/CardSustinereSistem.vue'
import carousel from 'vue-owl-carousel'
export default {
  props: ["mobile_component"],
  components: {
    'banner': Banner,
    'consultant': Consultant,
    'continut': Continut,
    'intrebari': Intrebari,
    'secret-unu': SecretUnu,
    'secret-doi': SecretDoi,
    'secret-trei': SecretTrei,
    'prebiotic': CardPrebiotic,
    'celule-imunitare': CardCeluleImunitare,
    'sustinere-sistem': CardSustinereSistem,
    carousel,
  },
  data() {
    return {
      show_more: false,
    }
  },
  methods: {}

}
</script>

<style lang="scss">
.secretele-laptelui h2 {
  font-size: 40px;
  font-weight: 700;
  color: #17479E;
  margin-bottom: 18px;
}

.secretele-laptelui h2 span {
  font-size: 20px;
  font-weight: 400;


}

.bk-gray-dark{
  background: #F2F0ED;
}

.secretele-laptelui p{
  width: 95%;
  max-width: 860px;
  margin: auto;
  text-align: center;
}
.secret--container-content p{
  text-align: left;
  color: #707070;
}

.secret--container-quote{
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 0
;
}
.secretele-laptelui p span {
  font-weight: 700;
  color: #17479E;
}

.secretele-laptelui .blue {
  border-left: 1px solid #17479E;
  padding-left: 15px;
}

.secretele-laptelui h3 {
  font-size: 20px;
  color: #17479E;
  font-weight: 700;
  padding-top: 15px;
  margin-bottom: 15px;

}

.secretele-laptelui .bk-blue-light p {
  color: #029FE3 !important;
}
.secret-container{
  max-width: 738px;
}
.secret-blue {
  padding: 25px 0;
  .container{
    max-width: 900px;
    padding: 0;
  }
  p{
    font-weight: 500;
  }

}
.secret-white {
  color: #707070;
  padding: 40px 0 75px;
}

.secretele-laptelui {
  text-align: center;
  overflow: hidden;

}

.secret-blue-margin{
  margin-bottom: -40px;
}

.bk-blue {
  background: #C4E4F9;
  padding: 15px;
}

.secretele-laptelui .secret-blue-margin{
  margin-bottom: -40px;
}

.padding-one {
  padding: 15px;
}

.secretele-laptelui .bk-gray-dark {
  background: #F2F0ED;
  border-radius: 20px;
  padding: 25px;
  margin: 40px 0 60px;
  min-height: 300px;
  max-height: 300px;
  text-align: left;
}

.secretele-laptelui .bk-gray-dark-margin{
  margin: 40px 0 0;
}


.secretele-laptelui .bk-gray-dark p{
  text-align: left;
}

.secretele-laptelui .logo-secret {
  min-height: 55px;
}


.middle-banner{
  background-image: url("../assets/images/image-secretele-laptelui/secretele-2.png");
  height: 400px;
  background-repeat: no-repeat;
  background-size: cover;
}
.p-gray {
  color: #A0A0A0;
  font-size: 12px;
  margin: 0;
}

@media screen and (max-width: 992px) {
  .middle-banner{
    background-image: url("../assets/images/image-secretele-laptelui/secretele-2-mobile.png");
    height: 274px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .questions--container-img img{
    width: 86px;
    height: auto;
  }
.secretele-laptelui .secret-blue{
  padding: 20px;

}
.secretele-laptelui .secret-blue-margin, .secret-blue-margin{
    margin-bottom: -40px !important;
  }

  .secretele-laptelui h2{
    font-size: 26px;
    line-height: 30px;
  }

  .secret--container-quote img{
    width: 30px;
    height: auto;
  }


  .secretele-laptelui .bk-blue-light {
    min-height: 100%;
    max-height: 100%;


  }
}

@media screen and (max-width: 576px) {
  .secretele-laptelui .secret-blue-margin, .secret-blue-margin{
    margin-bottom: 0px !important;
    padding-bottom: 40px;
  }
  .secret-white{
    padding: 30px 0;
  }
  .secretele-laptelui .logo-secret {
   width: 38px;
    height: auto;
  }
  .secretele-laptelui .bk-gray-dark{
    max-height:none;
    width: 95%;
  }
  .p-gray {
  text-align: left;
  }
}
</style>
